import angular from 'angular';

function OrdersController($scope) {
  $scope.orders = {
    model: 'Your spankin new application.orders.default view!',

    init: function () {},

    success: {
      init: function (response) {},
    },

    error: {
      init: function (response) {},
    },
  };

  $scope.orders.init();
}

OrdersController.$inject = ['$scope'];

export const OrdersControllerModule = angular
  .module('acme.view.application.orders.controllers', [])

  .controller('OrdersController', OrdersController).name;
